import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleAdmDicType } from './data';
import { addAdmDic, editAdmDic, getAdmDicPage, removeAdmDic } from './service';

export type AdmDicState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleAdmDicType[];
};

type AdmDicModelType = {
  namespace: string;
  state: AdmDicState;
  reducers: {
    AdmDicReducer: Reducer<AdmDicState>;
  };
  effects: {
    fetchAdmDicPageEffect: Effect;
    refreshDataEffect: Effect;
    addAdmDicEffect: Effect;
    editAdmDicEffect: Effect;
    removeAdmDicEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const AdmDicModel: AdmDicModelType = {
  namespace: 'admDic',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    AdmDicReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as AdmDicState;
    },
  },

  effects: {
    *fetchAdmDicPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getAdmDicPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'AdmDicReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.admDic.current);
      const pageSize = yield select((state: any) => state.admDic.pageSize);
      yield put({
        type: 'fetchAdmDicPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addAdmDicEffect: createEffect(addAdmDic),
    editAdmDicEffect: createEffect(editAdmDic),
    removeAdmDicEffect: createEffect(removeAdmDic),
  },

  subscriptions: {
    setup() {},
  },
};

export default AdmDicModel;
